import type { ReactElement } from "react";
import React from "react";

export const SearchIcon = ({ className = "" }: { className?: string }): ReactElement => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask id="mask0_999_8857" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_999_8857)">
        <path
          d="M8.62494 14.0577C10.1388 14.0577 11.4201 13.5326 12.4687 12.4824C13.5173 11.4323 14.0416 10.1491 14.0416 8.63302C14.0416 7.1169 13.5173 5.83375 12.4687 4.78358C11.4201 3.73342 10.1388 3.20833 8.62494 3.20833C7.11105 3.20833 5.8298 3.79244 4.78119 4.96067C3.73258 6.12889 3.20827 7.35301 3.20827 8.63302C3.20827 10.1491 3.73258 11.4323 4.78119 12.4824C5.8298 13.5326 7.11105 14.0577 8.62494 14.0577ZM8.62494 15.8333C6.63016 15.8333 4.93008 15.1307 3.52471 13.7256C2.11932 12.3205 1.41663 10.6207 1.41663 8.62627C1.41663 6.63184 2.1192 4.93164 3.52433 3.52567C4.92946 2.11968 6.62924 1.41669 8.62367 1.41669C10.6181 1.41669 12.3183 2.11938 13.7243 3.52477C15.1303 4.93015 15.8333 6.62767 15.8333 8.61733C15.8333 9.47443 15.6927 10.2892 15.4117 11.0616C15.1306 11.834 14.738 12.5293 14.2339 13.1474L17.9438 16.7115C18.1287 16.8807 18.2211 17.0878 18.2211 17.3328C18.2211 17.5778 18.1287 17.7941 17.9438 17.9815C17.7729 18.1552 17.571 18.2406 17.3381 18.238C17.1052 18.2353 16.8963 18.1485 16.7115 17.9775L12.947 14.3798C12.3518 14.8375 11.6852 15.1942 10.9473 15.4499C10.2094 15.7055 9.43526 15.8333 8.62494 15.8333Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
